"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PreferencesContext_1 = require("../context/PreferencesContext");
function useCheckExperimentalFeature() {
    const preferences = (0, PreferencesContext_1.usePreferences)();
    return (preferences.current.display.general?.experimentalFeatures?.display || false);
}
exports.default = useCheckExperimentalFeature;
